module.exports = __webpack_public_path__ + "img/logo_pam_flecha_amarela.82056f01.png";